// src/components/ContactSales.js - Fixed with all state variables
import React, { useState } from 'react';
import './ContactSales.css';

const ContactSales = ({ onClose, productName = "Smart AI Analyzer" }) => {
    const [formData, setFormData] = useState({
        name: '',
        company: '',
        email: '',
        phone: '',
        message: ''
    });
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isLoading, setIsLoading] = useState(false);  // ADD THIS
    const [error, setError] = useState('');              // ADD THIS

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');  // Clear previous errors

        try {
            const apiUrl = process.env.REACT_APP_AUTH_URL;// || 'http://localhost:3000';
            const response = await fetch(apiUrl + '/api/auth/contact/sales', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData)
            });

            const data = await response.json();

            if (data.success) {
                setIsSubmitted(true);
                setTimeout(() => onClose(), 2000);
            } else {
                setError(data.error || 'Failed to submit');
            }
        } catch (error) {
            console.error('Error:', error);
            setError('Network error. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    // Inline styles
    const buttonStyle = {
        width: '100%',
        background: isLoading ? '#64748b' : 'linear-gradient(135deg, #ec4899 0%, #8b5cf6 50%, #6366f1 100%)',
        backgroundSize: '200% auto',
        border: 'none',
        padding: '0.9rem',
        borderRadius: '60px',
        color: 'white',
        fontWeight: '700',
        fontSize: '1rem',
        cursor: isLoading ? 'not-allowed' : 'pointer',
        transition: 'all 0.3s',
        marginTop: '0.5rem',
        opacity: isLoading ? 0.7 : 1
    };

    const labelStyle = {
        display: 'block',
        color: 'white',
        fontSize: '0.85rem',
        fontWeight: '600',
        marginBottom: '0.5rem'
    };

    const inputStyle = {
        width: '100%',
        padding: '0.75rem 1rem',
        background: 'rgba(255, 255, 255, 0.08)',
        border: '1px solid rgba(255, 255, 255, 0.15)',
        borderRadius: '12px',
        color: 'white',
        fontSize: '0.9rem'
    };

    return (
        <div className="contact-overlay" onClick={onClose}>
            <div className="contact-modal" onClick={(e) => e.stopPropagation()}>
                <button className="close-modal" onClick={onClose}>✕</button>

                {!isSubmitted ? (
                    <>
                        <div className="contact-header">
                            <div className="contact-icon">💼</div>
                            <h2>Contact Sales</h2>
                            <p>Get enterprise pricing and tailored solutions</p>
                        </div>

                        {/* Show error message if any */}
                        {error && (
                            <div style={{
                                background: 'rgba(239, 68, 68, 0.1)',
                                border: '1px solid rgba(239, 68, 68, 0.3)',
                                borderRadius: '12px',
                                padding: '0.75rem',
                                marginBottom: '1rem',
                                color: '#f87171',
                                fontSize: '0.85rem',
                                textAlign: 'center'
                            }}>
                                {error}
                            </div>
                        )}

                        <form onSubmit={handleSubmit} className="contact-form">
                            <div className="form-row">
                                <div className="form-group">
                                    <label style={labelStyle}>Full Name *</label>
                                    <input
                                        type="text"
                                        name="name"
                                        required
                                        value={formData.name}
                                        onChange={handleChange}
                                        placeholder="John Doe"
                                        style={inputStyle}
                                        disabled={isLoading}
                                    />
                                </div>
                                <div className="form-group">
                                    <label style={labelStyle}>Company Name *</label>
                                    <input
                                        type="text"
                                        name="company"
                                        required
                                        value={formData.company}
                                        onChange={handleChange}
                                        placeholder="Your Company"
                                        style={inputStyle}
                                        disabled={isLoading}
                                    />
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group">
                                    <label style={labelStyle}>Work Email *</label>
                                    <input
                                        type="email"
                                        name="email"
                                        required
                                        value={formData.email}
                                        onChange={handleChange}
                                        placeholder="john@company.com"
                                        style={inputStyle}
                                        disabled={isLoading}
                                    />
                                </div>
                                <div className="form-group">
                                    <label style={labelStyle}>Phone Number</label>
                                    <input
                                        type="tel"
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        placeholder="+1 234 567 8900"
                                        style={inputStyle}
                                        disabled={isLoading}
                                    />
                                </div>
                            </div>

                            <div className="form-group">
                                <label style={labelStyle}>How can we help? *</label>
                                <textarea
                                    name="message"
                                    required
                                    rows="4"
                                    value={formData.message}
                                    onChange={handleChange}
                                    placeholder="Tell us about your incident analysis needs..."
                                    style={{ ...inputStyle, resize: 'vertical' }}
                                    disabled={isLoading}
                                ></textarea>
                            </div>

                            <div className="checkbox-group">
                                <label className="checkbox-label">
                                    <input
                                        type="checkbox"
                                        required
                                        style={{ width: '16px', height: '16px', margin: '0 8px 0 0' }}
                                        disabled={isLoading}
                                    />
                                    <span style={{ color: '#cbd5e1', fontSize: '0.8rem' }}>I agree to receive communications about {productName}</span>
                                </label>
                            </div>

                            <button type="submit" style={buttonStyle} disabled={isLoading}>
                                {isLoading ? 'Sending...' : 'Send Message →'}
                            </button>
                        </form>

                        <div className="contact-alternative">
                            <p style={{ color: '#94a3b8', fontSize: '0.75rem' }}>Or reach us directly:</p>
                            <div className="direct-contacts">
                                <span style={{ color: '#cbd5e1', fontSize: '0.8rem' }}>📧 sales@smartaianalyzer.com</span>
                                <span style={{ color: '#cbd5e1', fontSize: '0.8rem' }}>📞 +1 (888) 123-4567</span>
                            </div>
                        </div>
                    </>
                ) : (
                    <div className="success-message">
                        <div className="success-icon">✓</div>
                        <h3>Thank You!</h3>
                        <p>Our sales team will contact you within 24 hours.</p>
                        <button onClick={onClose} className="close-success-btn">Close</button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ContactSales;